import { DELIVERY_DATE_STATUS } from "components/pages/deliveryDate/DeliveryDatePage.constants";
import {
  IAddUpdateDeliveryDatePageState,
  IWarehouseCategory,
} from "../interfaces/Index";

export const normalizeDeliveryDatePayload = (
  request: IAddUpdateDeliveryDatePageState
): any => {
  const payload: IAddUpdateDeliveryDatePageState = {
    warehouseId: request.warehouseId,
    status: !request.status
      ? DELIVERY_DATE_STATUS.DEFAULT
      : DELIVERY_DATE_STATUS.CUSTOM,
    orderReceivedStartTime: request.orderReceivedStartTime,
    orderReceivedEndTime: request.orderReceivedEndTime,
    expectedDeliveryAt: request.expectedDeliveryAt,
  };
  return payload;
};

export const normalizeWarehouse = (warehouse: any) => {
  return warehouse.map((type: IWarehouseCategory) => {
    return (
      {
        id: type.id,
        value: type.id,
        label: type.name,
      } || []
    );
  });
};
